import { render, staticRenderFns } from "./LoginModal.vue?vue&type=template&id=8aa3133a&scoped=true&"
import script from "./LoginModal.vue?vue&type=script&lang=js&"
export * from "./LoginModal.vue?vue&type=script&lang=js&"
import style0 from "./LoginModal.vue?vue&type=style&index=0&id=8aa3133a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa3133a",
  null
  
)

export default component.exports